export const SelectColor = (channel, item = 'default', alias = '') => {
	let color = '#6f6f70';

	let data = [];

	if (channel === 'google') {
		data = {
			impressions: '#6F6F70',
			Desktop: '#F81846',
			Mobile: '#F37C99',
			Mulheres: '#F37C99',
			clicks: '#F81846',
			men: '#79B4EA',
			Homens: '#79B4EA',
			women: '#F37C99',
		};

		color = '#000000';

		return data[item] || color;
	}

	if (channel === 'instagram') {
		data = {
			impressions: '#6944C2',
			Desktop: '#BE3086',
			Mobile: '#A44B9F',
			Mulheres: '#BE3086',
			women: '#BE3086',
			clicks: '#BE3086',
			men: '#A44B9F',
			Homens: '#A44B9F',
			mobile_impressions: '#A44B9F',
			desktop_impressions: '#BE3086',
		};

		color = '#BE3086';

		if (item === 'Desktop' && (alias === 'pie_face_device_click' || alias === 'desktop_clicks')) {
			color = '#C04987';
			return color;
		}

		if (item === 'Mobile' && (alias === 'pie_face_device_click' || alias === 'mobile_clicks')) {
			color = '#A44C9F';
			return color;
		}

		if (item === 'Desktop' && (alias === 'pie_face_device_impression' || alias === 'desktop_impressions')) {
			color = '#775DB3';
			return color;
		}

		if (item === 'Mobile' && (alias === 'pie_face_device_impression' || alias === 'mobile_impressions')) {
			color = '#6B53C2';
			return color;
		}

		return data[alias || item] || color;
	}

	if (channel === 'facebook') {
		data = {
			impressions: '#6F6F70',
			Desktop: '#1877F2',
			Mobile: '#4D9EFD',
			Mulheres: '#1877F2',
			clicks: '#1877F2',
			men: '#7BACED',
			Homens: '#4D9EFD',
			women: '#1877F2',
		};

		color = '#1F7AF2';

		if (item === 'Desktop' && (alias === 'pie_face_device_click' || alias === 'desktop_clicks')) {
			color = '#1877F2';
			return color;
		}

		if (item === 'Mobile' && (alias === 'pie_face_device_click' || alias === 'mobile_clicks')) {
			color = '#4D9EFD';
			return color;
		}

		if (item === 'Desktop' && (alias === 'pie_face_device_impression' || alias === 'desktop_impressions')) {
			color = '#717171';
			return color;
		}

		if (item === 'Mobile' && (alias === 'pie_face_device_impression' || alias === 'mobile_impressions')) {
			color = '#939393';
			return color;
		}

		return data[alias || item] || color;
	}

	if (channel === 'facebook_instagram') {
		data = {
			impressions: '#6F6F70',
			Desktop: '#1877F2',
			Mobile: '#4D9EFD',
			Mulheres: '#1877F2',
			clicks: '#1877F2',
			men: '#7BACED',
			Homens: '#4D9EFD',
			women: '#1877F2',
			mobile_impressions: '#939393',
			desktop_impressions: '#717171',
		};

		color = '#1F7AF2';

		if (item === 'Desktop' && (alias === 'pie_face_device_click' || alias === 'desktop_clicks')) {
			color = '#1877F2';
			return color;
		}

		if (item === 'Mobile' && (alias === 'pie_face_device_click' || alias === 'mobile_clicks')) {
			color = '#4D9EFD';
			return color;
		}

		if (item === 'Desktop' && (alias === 'pie_face_device_impression' || alias === 'desktop_impressions')) {
			color = '#717171';
			return color;
		}

		if (item === 'Mobile' && (alias === 'pie_face_device_impression' || alias === 'mobile_impressions')) {
			color = '#939393';
			return color;
		}
	}

	return data[alias || item] || color;
};

export const Translate = (title) => {
	const data = {
		men: 'Homens',
		woman: 'Mulheres',
		clicks: 'Cliques',
		impressions: 'Impressões',
		text_ads: 'Anúncios de texto',
		adType: 'Anúncios',
		ad_group: 'Grupos de anúncios',
		cpc_average_cost: 'CPC médio (R$)',
		cpc: 'CPC médio (R$)',
		ctr: 'CTR (%)',
		cost: 'Custo',
		keywords: 'Palavras-chave',
		keyword: 'Palavras-chave',
		image_url: 'Anúncios de display',
		reach: 'Alcance',
		cpm: 'CPM médio (R$)',
		adset_name: 'Conjunto de anúncios',
	};

	return data[title];
};

export const renderKeysTable = (keys) => {
	const arrayTable = [];

	if (keys) {
		keys.map(key => (
			arrayTable.push({
				col: key,
				title: Translate(key),
			})
		));
	}

	return arrayTable;
};
